module.exports = __webpack_public_path__ + "static/media/Scan 11.b18d9361.jpeg";